import { gql } from "@apollo/client"
import { CONTRACT_FRAG } from "../vehicle-management/vehicle-management.fragments.gql"

const SCHEDULE_VEHICLE_FRAG = gql`
  fragment ScheduleVehicleFrag on VehicleType {
    id
    registrationNumber
    vehicleType {
      id
      category
      capacity
    }
    depot {
      id
      name
    }
  }
`
const VEHICLE_LIST_FRAG = gql`
  fragment VehicleListFrag on VehicleType {
    id
    registrationNumber
    estimatedAverage
    status
    createdAt
    owner {
      id
      fullName
      number
      status
    }
    driver {
      id
      fullName
      number
    }
    alerts {
      date
      message
    }
    currentContract {
      id
      totalPaid
      totalExpense
      totalOutstanding
      contractType {
        id
        name
      }
    }
    vehicleType {
      id
      name
      category
      capacity
      capacityUnit {
        id
        codename
      }
    }
    departments {
      id
      name
    }
    depot {
      id
      name
    }
  }
`

const VEHICLE_DETAILS_FRAG = gql`
  fragment VehicleDetailsFrag on VehicleType {
    id
    registrationNumber
    chassisNumber
    estimatedAverage
    dateBought
    status
    dimensions
    dimensionUnit {
      id
      name
    }
    owner {
      id
      fullName
    }
    driver {
      id
      fullName
    }
    fuelType {
      id
      name
    }
    fuelTankCapacity
    vehicleType {
      id
      name
      category
    }
    departments {
      id
      name
    }
    depot {
      id
    }
    modelName
    insurance {
      id
      name
      idNumber
      issuedOn
      validTill
      photo
    }
  }
`

const VEHICLE_OWNER_FRAG = gql`
  fragment VehicleOwnerFrag on BaseUserType {
    id
    firstName
    lastName
    status
    number
    customerId
    companies {
      id
      name
    }
    kycDetails {
      id
      photo
      kycType {
        id
        name
      }
      idNumber
    }
    address {
      id
      village
      pincode
      state
      district
      taluka
      latitude
      longitude
      address
    }
    bankDetails {
      id
      ifscCode
      accountNumber
      accountHolderName
      branchName
      attachments {
        id
        url
        mediaType
      }
      bank {
        id
        name
      }
    }
  }
`

const VEHICLE_DRIVER_FRAG = gql`
  fragment VehicleDriverFrag on BaseUserType {
    id
    firstName
    lastName
    number
    kycDetails {
      id
      photo
      kycType {
        id
        name
      }
      idNumber
    }
    licenceDetails {
      id
      idNumber
      issuedOn
      validTill
      photo
    }
  }
`

export const ALL_VEHICLE_LIST_FRAG = gql`
  fragment AllVehicleListFrag on VehicleType {
    id
    status
    registrationNumber
    owner {
      id
      fullName
    }
    driver {
      id
      fullName
    }
    alerts {
      date
      message
    }
    currentContract {
      ...ContractFrag
    }
    contracts {
      ...ContractFrag
    }
    departments {
      id
      name
    }
    vehicleType {
      id
      category
      name
    }
  }
  ${CONTRACT_FRAG}
`
export {
  VEHICLE_DRIVER_FRAG,
  VEHICLE_OWNER_FRAG,
  VEHICLE_DETAILS_FRAG,
  VEHICLE_LIST_FRAG,
  SCHEDULE_VEHICLE_FRAG,
}
